export default {
      id: "icon-eu-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-eu",
      toString: function () {
        return this.url;
      }
    }